import $ from "jquery";

var $body = $('body');
var $backToTop = $('#back-to-top');
var updateScrollToTop = function() {
    if(window.pageYOffset < 300 && !$backToTop.hasClass('is-hidden')) {
        $backToTop.fadeOut();
    } 
    else{
        $backToTop.fadeIn();
    }
};

if($body.hasClass('single-product')) {
    $backToTop.removeClass('is-hidden');
}

$backToTop.on('click', function() {
    $('html, body').animate({
        scrollTop: 0
    }, 500);
});

updateScrollToTop();
$(window).on('scroll', updateScrollToTop);